<template>
  <div class="article-details">
    <div class="article-container">
      <!-- 标题 -->
      <h1 class="article-title">{{ article.title }}</h1>
      
      <!-- 元信息 -->
      <div class="article-meta">
        <span class="meta-item">
          <i class="icon-source"></i>
          来源: {{ article.source }}
        </span>
        <span class="meta-item">
          <i class="icon-time"></i>
          时间: {{ article.date }}
        </span>
      </div>
      
      <!-- 文章内容 -->
      <div class="article-content" v-html="article.content"></div>
      
      <!-- 署名和日期 -->
      <div class="article-footer">
        <p class="signature">{{ article.signature }}</p>
        <p class="publish-date">{{ article.publishDate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleDetails',
  data() {
    return {
      article: {
        title: '2024年心理测量技能培训证书领取通知',
        source: '心理咨询行业协会',
        date: '2024-06-25',
        content: '由我会主办、济宁医学院精神卫生学院承办的第2期"心理测量"技能培训已顺利结束，请相关学员与秘书处联系培训证书相关事宜。',
        signature: '山东省心理咨询行业协会',
        publishDate: '2024年6月25日'
      }
    }
  },
  mounted() {
    // 从路由参数或API获取文章详情
    this.fetchArticleDetails()
  },
  methods: {
    fetchArticleDetails() {
      // TODO: 实现文章详情获取逻辑
      // const articleId = this.$route.params.id
      // 调用API获取文章详情
      console.log('Article ID:', this.$route.params.id)
    }
  }
}
</script>

<style scoped>
.article-details {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 40px 20px;
}

.article-container {
  max-width: 1000px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 60px 80px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 标题样式 */
.article-title {
  font-size: 28px;
  color: #4A90E2;
  text-align: center;
  margin-bottom: 30px;
  font-weight: 600;
  line-height: 1.5;
}

/* 元信息区域 */
.article-meta {
  background-color: #F0F0F0;
  padding: 15px 30px;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  border-radius: 4px;
}

.meta-item {
  font-size: 14px;
  color: #666666;
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-source::before,
.icon-time::before {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
}

.icon-source::before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23666'%3E%3Cpath d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z'/%3E%3C/svg%3E");
}

.icon-time::before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23666'%3E%3Cpath d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'/%3E%3C/svg%3E");
}

/* 文章内容 */
.article-content {
  font-size: 16px;
  line-height: 2;
  color: #333333;
  text-align: justify;
  margin-bottom: 60px;
  text-indent: 2em;
}

/* 底部署名和日期 */
.article-footer {
  text-align: right;
  margin-top: 40px;
}

.signature {
  font-size: 16px;
  color: #333333;
  margin-bottom: 10px;
  line-height: 1.8;
}

.publish-date {
  font-size: 16px;
  color: #333333;
  line-height: 1.8;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .article-container {
    padding: 30px 20px;
  }
  
  .article-title {
    font-size: 22px;
  }
  
  .article-meta {
    flex-direction: column;
    gap: 10px;
    padding: 15px 20px;
  }
  
  .article-content {
    font-size: 15px;
  }
}
</style>
